import { render, staticRenderFns } from "./otherCapital.vue?vue&type=template&id=73d05be6&"
import script from "./otherCapital.vue?vue&type=script&lang=js&"
export * from "./otherCapital.vue?vue&type=script&lang=js&"
import style0 from "./otherCapital.vue?vue&type=style&index=0&id=73d05be6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports